import { useContext } from 'react'

import { getMinifiedLocaleCurrencyStringFromMoneyAmount } from 'utils'

import { SessionContext } from '../shared'
import { type MarketplaceProductVariant } from '../shared/types'

type VariantSelectorProps = {
  variants: MarketplaceProductVariant[];
  selectedVariant: MarketplaceProductVariant;
  onSelectVariant: (variant: MarketplaceProductVariant) => void;
}

export const VariantSelector = ({ variants, selectedVariant, onSelectVariant }: VariantSelectorProps) => {
  const sessionContext = useContext(SessionContext)
  const isPublicView = sessionContext.publicView

  return (
    <div className='flex flex-col gap-2'>
      {variants.map((variant) => {
        const isSelected = variant.id === selectedVariant.id
        const labelClasses = `flex items-start p-4 border rounded-lg cursor-pointer transition w-full ${
          isSelected
            ? 'border-thatch-500 bg-purple-50/50'
            : 'border-gray-200 bg-white hover:bg-gray-50'
        }`

        return (
          <label
            key={variant.id}
            className={labelClasses}
          >
            <div className='flex items-center justify-between w-full'>
              <input
                type='radio'
                name='productVariant'
                value={variant.id}
                checked={isSelected}
                onChange={() => onSelectVariant(variant)}
                className='sr-only'
              />
              <span className='flex-grow body'>{variant.name}</span>
              <span className='ml-auto text-right'>
                {!isPublicView && (
                  <>
                    <span>
                      {getMinifiedLocaleCurrencyStringFromMoneyAmount(variant.discounted_price ?? variant.base_price)}
                    </span>
                    {variant.discounted_price !== null && variant.base_price !== null && (
                      <span className='ml-2 body-sm text-gray-500 line-through'>
                        {getMinifiedLocaleCurrencyStringFromMoneyAmount(variant.base_price)}
                      </span>
                    )}
                  </>
                )}
              </span>
            </div>
          </label>
        )
      })}
    </div>
  )
}
